"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  white_label: {
    powered_by: 'Desarrollado por'
  },
  errors: {
    parameter_not_unique: 'Este valor ya está en uso.',
    blank: 'Este campo es obligatorio.'
  },
  forms: {
    phone: 'Haga clic en el enlace enviado por SMS para verificar su envío.',
    email: 'Haga clic en el enlace enviado por e-mail para verificar su envío.',
    phone_and_email: 'Haga clic en los enlaces enviados por SMS y e-mail para verificar su envío.',
    none: 'Su envío ha sido recibido.'
  }
};
exports.default = _default;